import Big from 'big.js'

import { isNumber } from './number'

export const formatNumber = ({
  value,
  emptyOnZero = true,
  delimiter = '\u00A0',
  precision = 0,
  /*
   * Режим форматирования для табличного вида
   * в сплошном тексте четырёхзначное число прекрасно читается без пробелов.
   * Но в таблице лучше всегда использовать пробелы, чтобы тысячи выравнивались независимо от размерности чисел.
   */
  tableView = false,
  /** Флаг для вывода числа без нулевой дробной части * */
  isWithoutZeroDecimal = false
}: {
  value: number | string | undefined
  delimiter?: string
  emptyOnZero?: boolean
  isWithoutZeroDecimal?: boolean
  precision?: number
  tableView?: boolean
}) => {
  if (!isNumber(value)) {
    return ''
  }

  const rounded = Big(value).round(precision)
  const hasRemainder = rounded.mod(1).toNumber() > 0
  let number = rounded.toFixed(!isWithoutZeroDecimal || hasRemainder ? precision : 0)

  if (emptyOnZero && !+number) {
    return ''
  }

  number = number.replace('.', ',')

  if (tableView || (!tableView && Big(value).e >= 4)) {
    return number.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`)
  }

  return number
}
